const convertToUnixTimestamp = date => date.unix().toString();
export default convertToUnixTimestamp;
//# sourceMappingURL=convertToUnixTimestamp.js.map